import * as React from 'react';
import { NavLink as RouterNavLink } from 'react-router-dom';
import {
    Collapse,
    Container,
    Nav,
    Navbar,
    NavbarToggler,
    NavItem
} from 'reactstrap';
import { compose, setDisplayName } from 'recompose';
import getClientEnvironment from '../getClientEnvironment';
import LoginDropdown from './Login/LoginDropdown';
import { ShowIfLoggedIn } from './Login/ShowIfLoggedIn';
import './MainNavbar.scss';
import * as siteLogo from './site-icon-small.svg';
import {
    ToggleStateProps,
    withQueryStringToggleState
} from './withToggleState';

const config = getClientEnvironment();

export default compose<ToggleStateProps, any>(
    withQueryStringToggleState('menu'),
    setDisplayName('MainNavbar')
)(({ active, toggle }: ToggleStateProps) => (
    <Navbar
        dark={true}
        expand="sm"
        className="main-navbar navbar-toggleable-sm bg-dark"
    >
        <Container>
            <RouterNavLink to="/" className="navbar-brand">
                <img
                    alt={`${config.TITLE} logo`}
                    src={siteLogo}
                    className="site-logo mr-2"
                />
                {config.TITLE}
            </RouterNavLink>
            <NavbarToggler onClick={toggle} />
            <Collapse isOpen={active} navbar={true}>
                <Nav navbar={true} className="mr-auto">
                    <ShowIfLoggedIn>
                        <NavItem>
                            <RouterNavLink
                                to="/activities"
                                className="nav-link"
                            >
                                My activities
                            </RouterNavLink>
                        </NavItem>
                    </ShowIfLoggedIn>
                    <NavItem>
                        <RouterNavLink to="/examples" className="nav-link">
                            Examples
                        </RouterNavLink>
                    </NavItem>
                    <NavItem>
                        <RouterNavLink to="/about" className="nav-link">
                            About
                        </RouterNavLink>
                    </NavItem>
                </Nav>
                <Nav navbar={true} className="ml-auto">
                    <LoginDropdown />
                </Nav>
            </Collapse>
        </Container>
    </Navbar>
));



// WEBPACK FOOTER //
// ./src/client/components/MainNavbar.tsx